import { Outlet, useParams } from 'react-router-dom';

import { supportedLanguages } from '@/i18next';
import NotFound from '@/pages/NotFound';

import NoIndexMeta from './NoIndexMeta';

function LocalizedLayout() {
	const { lang } = useParams();

	if (lang && !supportedLanguages.includes(lang)) {
		return (
			<>
				<NoIndexMeta />
				<NotFound />
			</>
		);
	}

	return <Outlet />;
}

export default LocalizedLayout;
